import React from 'react';
import styled from 'styled-components';
import { css } from '/imports/ui/css';

const CatalogStyled = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  .catalog-tools {
    margin-bottom: 1rem;
    display: flex;
    gap: 1rem;
    align-items: center;
    .search {
      margin-top: 1px;
    }
    .custom-tools {
      margin-left: auto;
    }
    .custom-tools-mobile-opener {
      display: none;
    }
    .filters {
      margin-left: auto;
      display: flex;
      gap: 1rem;
      .filters-label {
        ${css.flexVerticalCenter};
      }
    }
    .filter {
      width: auto;
    }
    ${css.mobileMedia} {
      width: 100%;
      .search {
        input {
          max-width: 15rem;
        }
      }
      .custom-tools {
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        background: ${css.white};
        width: calc(100% - 4rem);
        padding: 1rem;
        border: 2px solid ${css.primaryColor};
        border-radius: ${css.inputBorderRadius};
        margin: auto;
        margin-right: auto;
        .filters {
          gap: 0.5rem;
        }
        &.open {
          display: block;
          z-index: 3;
        }
      }
      .custom-tools-mobile-opener {
        ${css.flexVerticalCenter};
        margin-left: auto;
        .icon {
          ${css.flexVerticalCenter};
          svg {
            width: 2rem;
            * {
              stroke: ${css.grey5};
              stroke-width: 1;
            }
          }
        }
        &.open {
          svg {
            * {
              stroke: ${css.primaryColor};
              stroke-width: 2;
            }
          }
        }
      }
    }
  }
  .catalog-stats {
    font-size: 0.85rem;
    color: ${css.grey4};
    padding: 0.5rem 1rem;
    border-top: 1px solid ${css.grey6};
  }
  .table {
    .row-select {
      .icon.checkmark {
        top: 0;
      }
    }
  }
`;

interface CatalogProps {
  children: React.ReactNode;
  className?: string;
}

/** Layout wrapper for a catalog view (tools bar, stats, table). */
export const Catalog = (props: CatalogProps) => {
  return (
    <CatalogStyled className={`catalog ${props.className || ''}`}>
      {props.children}
    </CatalogStyled>
  );
};